import hasCapitalizedFields from './hasCapitalizedFields';

const hasRemedials = (remedials) => {
  return {
    getRemedials() {
      return remedials.map((remedial) => {
        return Object.assign(
          { ...remedial },
          hasCapitalizedFields(remedial),
        );
      });
    },
  };
};

export default hasRemedials;
